/**
 * Created by camiel on 29/05/2017.
 */

import Utils from "lib/src/utils";

export const CHARACTER = Utils.getParameterByName("character") || "chloe";

const MAIN_COLOR_OFFSETS_PER_CHAR = {
  arabella: { red: 250, green: 164, blue: 61 },
  chloe: { red: 239, green: 88, blue: 157 },
};

export const MAIN_COLOR_OFFSET = MAIN_COLOR_OFFSETS_PER_CHAR[CHARACTER];

const KEY_PRESSED_COLOR_OFFSETS_PER_CHAR = {
  arabella: { red: 249, green: 206, blue: 153 },
  chloe: { red: 186, green: 155, blue: 200 },
};

export const KEY_PRESSED_COLOR_OFFSET = KEY_PRESSED_COLOR_OFFSETS_PER_CHAR[CHARACTER];



// WEBPACK FOOTER //
// ./~/string-replace-webpack-plugin/loader.js?id=93fdkru8er!./src/constants.ts